"use strict";

var FreePlanLink = require("./free-plan-link");
var PlanCardProLoading = require("./plan-card-pro-loading");
var PlanCardPro = require("./plan-card-pro");
var SignalActions = require("app/shared/actions/signal-actions");
var config = require("app/util/config/config");
var AGENDOR_SUPPORT_PHONE = config.support.phone;
var AGENDOR_SUPPORT_EMAIL = config.support.email;

var _ = require("underscore");

var PlanSelector = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    accountUsers: React.PropTypes.number,
    currentPlan: React.PropTypes.object,
    expired: React.PropTypes.bool,
    onSelect: React.PropTypes.func,
    basePlan: React.PropTypes.object,
    subscriptionState: React.PropTypes.string,
    trial: React.PropTypes.string,
    userIsAdmin: React.PropTypes.bool,
    usersNumber: React.PropTypes.number
  },
  getDefaultProps: function() {
    return {
      basePlan: null,
      usersNumber: null
    };
  },
  onUserPick: function (usersNumber) {
    // Disable downgrade for customers who have a special discount
    // They were migrated from old plans (Basico, Ideal, Agendor, etc)
    // and received a discount to keep paying the same
    // This should be a temporary solution
    if (this.props.currentPlan != null) {
      try {
        var accountDiscountId = this.getCurrentDiscountId(this.props.currentPlan);
        var currentPlanMaxUsers = this.props.currentPlan.maxUsers;
        var hasOldPlansDiscount = accountDiscountId != null && accountDiscountId >= 141 && accountDiscountId <= 151;
        if (hasOldPlansDiscount) {
          if (usersNumber < currentPlanMaxUsers) {
            var message = "Não é possível diminuir o plano pois você possui um desconto especial. Para remover o desconto e realizar o downgrade, entre em contato com a nossa equipe pelo telefone " + AGENDOR_SUPPORT_PHONE + " ou pelo email " + AGENDOR_SUPPORT_EMAIL + ".";
            SignalActions.show({ message: message, type: "warning" });
            return false;
          }
        }
      } catch (error) {
        captureError(error);
      }
    }

    if (this.isUserNumberValid(usersNumber)) {
      this.props.onSelect(parseInt(usersNumber));
    } else if (usersNumber === "") {
      this.props.onSelect(0);
    }
  },
  getCurrentDiscountId: function (currentPlan) {
    var hasMonthlyDiscounts = currentPlan.monthlyDiscounts && currentPlan.monthlyDiscounts.length > 0;
    var hasDiscountId =  hasMonthlyDiscounts && _.has(currentPlan.monthlyDiscounts[0], "discountId");
    var discountId = null;
    try {
      if (hasDiscountId) {
        discountId = currentPlan.monthlyDiscounts[0].discountId;
      }
    } catch (error) {
      captureError(error);
    }
    return discountId;
  },
  isUserNumberValid: function (usersNumber) {
    return usersNumber > 0 && usersNumber <= 100;
  },
  createPlanFromBasePlan: function(basePlan) {
    var usersNumber = this.props.usersNumber;
    var defaultValue = basePlan.defaultValue? basePlan.defaultValue : basePlan.value;
    return {
      name: basePlan.name.replace(/\d/, usersNumber),
      defaultValue: defaultValue * usersNumber,
      value: basePlan.value * usersNumber,
      maxUsers: basePlan.maxUsers * usersNumber,
      planId: basePlan.planId + usersNumber - 1
    };
  },
  render: function() {
    var freePlanProps = {
      subscriptionState: this.props.subscriptionState,
      userIsAdmin: this.props.userIsAdmin,
      accountUsers: this.props.accountUsers,
      expired: this.props.expired,
      trial: this.props.trial,
    };
    var basePlan = this.props.basePlan;
    var loadedUsersNumber = this.props.usersNumber;

    var selectedPlan;
    if (loadedUsersNumber) {
      selectedPlan = this.createPlanFromBasePlan(basePlan);
    }

    return (
      <div className="planSelector mb-30">
        {
          loadedUsersNumber
            ? <PlanCardPro {...this.props}
                selectedPlan={selectedPlan}
                onUserPick={this.onUserPick} />
            : <PlanCardProLoading />
        }
        <FreePlanLink {...freePlanProps} />
      </div>
    );
  }
});

module.exports = PlanSelector;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-selector.jsx